import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videoData';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">福利视频导航</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              精选优质视频资源聚合平台，为您提供专业分类导航服务。覆盖电影、电视剧、综艺、动漫等8大核心品类，持续更新。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-primary-300 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-300 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-300 transition-colors">关于我们</Link></li>
              <li><Link to="/category/dianying" className="text-sm text-background-400 hover:text-primary-300 transition-colors">电影导航</Link></li>
              <li><Link to="/category/dianshiju" className="text-sm text-background-400 hover:text-primary-300 transition-colors">电视剧导航</Link></li>
              <li><Link to="/category/dongman" className="text-sm text-background-400 hover:text-primary-300 transition-colors">动漫导航</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@fulishipin.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-400"></i>
                <span>fulishipin2024</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 福利视频导航 - 精选优质视频资源聚合平台. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <Link to="/about" className="hover:text-primary-300 transition-colors">关于我们</Link>
            <span>|</span>
            <span>京ICP备2024000001号</span>
          </div>
        </div>
      </div>
    </footer>
  );
}